module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"add":"Add","cancel":"Cancel","title-image":"Please enter the image URL","title-link":"Please enter the link URL"},"fr_FR":{"add":"Ajouter","cancel":"Annuler","title-image":"Veuillez entrer l\u0027URL de l\u0027image","title-link":"Veuillez entrer l\u0027URL du lien"}}')
  delete Component.options._Ctor
}
